export enum QUERY_KEYS {
  addOfferToGroup = 'add-offer-to-group',
  createGroup = 'create-group',
  deleteGroup = 'delete-group',
  editGroup = 'edit-group',
  removeOfferFromGroup = 'remove-offer-from-group',
}
